import { Map, List, fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';

import * as licenseLib from 'libs/licenseLib';
import * as normal from 'libs/normalizer';

// action types
const INITIAL_STORE = 'license/INITIAL_STORE';
const CHANGE_PARAM = 'license/CHANGE_PARAM';
const RELOAD_LICENSE = 'license/RELOAD_LICENSE';
const GET_LICENSE = 'license/GET_LICENSE';
const ADD_LICENSE = 'license/ADD_LICENSE';
const UPDATE_LICENSE = 'license/UPDATE_LICENSE';
const DELETE_LICENSE = 'license/DELETE_LICENSE';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const changeParam = createAction(CHANGE_PARAM);
export const reloadLicense = createAction(RELOAD_LICENSE);
export const getLicense = createAction(GET_LICENSE, licenseLib.getLicense);
export const addLicense = createAction(ADD_LICENSE, licenseLib.addLicense);
export const updateLicense = createAction(UPDATE_LICENSE, licenseLib.updateLicense);
export const deleteLicense = createAction(DELETE_LICENSE, licenseLib.deleteLicense);

// initial state
const initialState = fromJS({
  data: {
    result: -1,
    success: [],
    fail: []
  },
  indexByNo: {},
  needReload: false,
  param: Map({
    filter: Map({}),
    sort: [{ field: 'licenseNo', order: 'DESC' }]
  }),
  totalPages: 0,
  totalCount: 0,
  targetAllCount: 0
});

// reducer
export default handleActions(
  {
    // store 초기화ㄴㄴㄴㄴㄴㄴㄴㄴㄴㄴㄴ
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [CHANGE_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['param', name], value);
    },
    [RELOAD_LICENSE]: (state, action) => {
      return state.set('needReload', true);
    },
    ...pender({
      type: GET_LICENSE,
      onSuccess: (state, action) => {
        const { data } = action.payload;
        const { offset, limit } = action.payload.config.params;

        // 전체 목록 수
        const totalCount = data.list.length > 0 ? data.list[0].rnum + offset : 0;
        // 전체 페이지 수
        const totalPages = Math.ceil(totalCount / limit);
        // 전체 대상자 수
        const targetAllCount = data.targetAllCount;

        const stateObj = normal.payloadDataSaver(state, 'data', data);
        return stateObj
          .set('needReload', false)
          .set('totalPages', totalPages)
          .set('totalCount', totalCount)
          .set('targetAllCount', targetAllCount)
          .set('indexByNo', fromJS(normal.listIndexByNo(data.list, 'licenseNo')));
      },
      onFailure: (state, action) => {
        console.log('GET_LICENSE 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),
    ...pender({
      type: DELETE_LICENSE,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('DELETE_LICENSE 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/license.js